import React, { ReactNode, useState } from 'react';
import { StyledCollapse, Title, Wrapper } from './styled';

interface ICollapseLine {
  title: string;
  text: string | ReactNode;
}

function CollapseLine({ title, text }: ICollapseLine): JSX.Element {
  const [isOpen, setOpen] = useState(false);
  const handleOpen = () => setOpen(!isOpen);
  return (
    <Wrapper data-testid="collapsible-line">
      <Title onClick={handleOpen}>{title}</Title>
      <StyledCollapse in={isOpen}>{text}</StyledCollapse>
    </Wrapper>
  );
}

export default CollapseLine;
